export default {
  '11': {
    name: '1:1',
    icon: 'square',
    description: 'Genèric',
    width: 720,
    height: 720,
    downloadScale: 2,
    minScale: 0.35,
    maxScale: 1,
    minMargin: -230,
    maxMargin: 0,
    ratio: 1
  },
  '45': {
    name: '4:5',
    icon: 'square',
    description: 'Instagram',
    width: 576,
    height: 720,
    downloadScale: 2.5,
    minScale: 0.35,
    maxScale: 1,
    minMargin: -230,
    maxMargin: 0,
    ratio: 4 / 5
  },
  '916': {
    name: '9:16',
    icon: 'mobile-android',
    description: 'Story',
    width: 405,
    height: 720,
    downloadScale: 2.75,
    minScale: 0.35,
    maxScale: 1,
    minMargin: -230,
    maxMargin: 0,
    ratio: 9 / 16
  },
  '169': {
    name: '16:9',
    icon: 'rectangle-landscape',
    description: 'Twitter',
    width: 720,
    height: 405,
    downloadScale: 2.75,
    minScale: 0.35,
    maxScale: 1,
    minMargin: -130,
    maxMargin: 0,
    ratio: 16 / 9
  },
  'event': {
    name: '16:9',
    icon: 'rectangle-landscape',
    description: 'Portada',
    width: 720,
    height: 405,
    downloadScale: 2.75,
    minScale: 0.35,
    maxScale: 1,
    minMargin: -130,
    maxMargin: 0,
    ratio: 16 / 9
  }
}
